import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Apis, ApiVersion} from '../constants/apis';
import {QuestionsResult} from '../models/questions-result.model';
import {Question} from '../models/question.model';
import {Result} from '../models/result.model';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

export interface QuizContext {
  domain: string;
  documentId: string;
  qaId: string;
  userId?: string;
  libraryId: string;
  documentClassIdLog: string;
  quizSheetName: string;
}

@Injectable({
  providedIn: 'root'
})
export class TrainingService {

  private apiUrl = environment.apiUrl;
  private baseUrl = environment.baseUrl;


  constructor(private http: HttpClient) {
  }

  questionsOrResult(ctx: QuizContext): Observable<QuestionsResult> {
    const url = this.toUrl(Apis.TRAINING, 'questionsOrResult', ApiVersion.V1);
    const params = {
      domain: ctx.domain,
      qaId: ctx.qaId,
      quizSheetName: ctx.quizSheetName,
      questions: true,
      ...(ctx.userId ? {userId: ctx.userId} : {})
    };
    return this.http.get<QuestionsResult>(url, {params});
  }

  submit(questions: Question[], ctx: QuizContext): Observable<Result> {
    const url = this.toUrl(Apis.TRAINING, 'submit', ApiVersion.V1);
    const params = {
      domain: ctx.domain,
      qaId: ctx.qaId,
      documentId: ctx.documentId,
      libraryId: ctx.libraryId,
      documentClassIdLog: ctx.documentClassIdLog,
      quizSheetName: ctx.quizSheetName,
      ...(ctx.userId ? {userId: ctx.userId} : {})
    };
    return this.http.post<Result>(url, {questions}, {params});
  }


  protected toUrl(root: string, method: string, version: string): string {
    return this.baseUrl + this.apiUrl + root + (method ? '/' + version + '/' + method : '/' + version);
  }
}
